var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.114258,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#7043FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6527 10.5376H14.5758C12.664 10.5376 11.1143 12.0874 11.1143 13.9991V22.3068L11.1191 22.4907C11.2146 24.317 12.7257 25.7684 14.5758 25.7684H14.8056L14.8066 28.7685L14.8133 28.8673C14.8836 29.3791 15.4934 29.6469 15.9217 29.3165L20.5195 25.7684H25.6527C27.5645 25.7684 29.1143 24.2186 29.1143 22.3068V13.9991C29.1143 12.0874 27.5645 10.5376 25.6527 10.5376ZM14.5758 11.9222H25.6527C26.7998 11.9222 27.7296 12.8521 27.7296 13.9991V22.3068C27.7296 23.4539 26.7998 24.3838 25.6527 24.3838H20.285L20.1939 24.3898C20.0736 24.4057 19.9591 24.4531 19.8622 24.5279L16.1903 27.3597V25.0759C16.1902 24.6936 15.8802 24.3838 15.498 24.3838H14.5758C13.4287 24.3838 12.4989 23.4539 12.4989 22.3068V13.9991C12.4989 12.8521 13.4287 11.9222 14.5758 11.9222Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepComment);
export default __webpack_public_path__ + "static/media/step_comment.da88f3c8c23ae36bc90522fff89c1056.svg";
export { ForwardRef as ReactComponent };